import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api";

export default function CreateCaseStudyPractice({ onCreated }) {
  const nav = useNavigate();

  // ================= FORM STATE =================
  const [title, setTitle] = useState("");
  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [duration, setDuration] = useState(30);

  // ================= DATA =================
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  // ================= LOAD CLASSES + SUBJECTS =================
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      nav("/login");
      return;
    }

    Promise.all([
      api.get("/admin/classes"),
      api.get("/admin/subjects"),
    ])
      .then(([classRes, subjectRes]) => {
        setClasses(Array.isArray(classRes.data) ? classRes.data : []);
        setSubjects(Array.isArray(subjectRes.data) ? subjectRes.data : []);
      })
      .catch((err) => {
        console.error(err);
        alert("❌ Failed to load classes / subjects");
      })
      .finally(() => setLoading(false));
  }, [nav]);

  // ================= SUBMIT =================
  const submit = async () => {
    if (!title.trim() || !classId || !subjectId) {
      alert("❌ Title, Class and Subject are required");
      return;
    }

    try {
      // 🔥 IMPORTANT: store response
      const res = await api.post("/admin/case-study-practice/create", {
        title: title.trim(),
        class_id: Number(classId),
        subject_id: Number(subjectId),
        duration_minutes: Number(duration),
      });

      const practiceSetId = res.data?.practice_set_id;
      if (!practiceSetId) {
        throw new Error("practice_set_id missing from API");
      }

      alert("✅ Case Study Practice Set Created");

      // reset (safe)
      setTitle("");
      setClassId("");
      setSubjectId("");
      setDuration(30);

      if (onCreated) onCreated();

      // 🔥 REDIRECT TO ASSIGN CASE STUDIES (STEP-2)
      nav(`/admin/case-study-practice/${practiceSetId}/assign`);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "❌ Creation failed");
    }
  };

  if (loading) {
    return <p style={{ padding: 20 }}>⏳ Loading...</p>;
  }

  return (
    <div style={box}>
      <h3 style={{ marginBottom: 16 }}>📘 Create Case Study Practice Set</h3>
      <button onClick={() => nav("/admin/dashboard")} style={backBtn}>
          ← Back to Dashboard
      </button>

      {/* TITLE */}
      <input
        style={input}
        placeholder="Practice Set Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      {/* CLASS */}
      <select
        style={input}
        value={classId}
        onChange={(e) => {
          setClassId(e.target.value);
          setSubjectId("");
        }}
      >
        <option value="">Select Class</option>
        {classes.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>

      {/* SUBJECT */}
      <select
        style={{
          ...input,
          background: classId ? "#ffffff" : "#f1f5f9",
          cursor: classId ? "pointer" : "not-allowed",
        }}
        value={subjectId}
        disabled={!classId}
        onChange={(e) => setSubjectId(e.target.value)}
      >
        <option value="">
          {classId ? "Select Subject" : "Select Class First"}
        </option>

        {subjects
          .filter((s) => s.class_id === Number(classId))
          .map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
      </select>

      {/* DURATION */}
      <input
        type="number"
        min={1}
        style={input}
        value={duration}
        onChange={(e) => setDuration(e.target.value)}
        placeholder="Duration (minutes)"
      />

      <button onClick={submit} style={btn}>
        Create Case Study Practice Set
      </button>
    </div>
  );
}

/* ================= STYLES ================= */

const box = {
  padding: 24,
  background: "#ffffff",
  borderRadius: 16,
  maxWidth: 520,
};

const input = {
  width: "100%",
  padding: 12,
  marginBottom: 12,
  borderRadius: 8,
  border: "1px solid #cbd5e1",
};

const btn = {
  padding: "12px 20px",
  background: "#2563eb",
  color: "#ffffff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 600,
};

const backBtn = { padding: "12px 24px", background: "#6b7280", color: "white", border: "none", borderRadius: "10px", cursor: "pointer", fontWeight: 600 };
